import script from "./PwaInstallButton.vue?vue&type=script&setup=true&lang=js"
export * from "./PwaInstallButton.vue?vue&type=script&setup=true&lang=js"

import "./PwaInstallButton.vue?vue&type=style&index=0&id=23faff7a&lang=scss"

const __exports__ = script;

export default __exports__